export default {
  SET_TOGGLE_CHART (state, value) {
    state.toggleChart = value
  },
  SET_ADVANCED_FILTER (state, {tabIndex, value}) {
    state.advancedFilter[tabIndex] = value
  },
  SET_SELECTED_HEADERS (state, selectedHeaders) {
    state.selectedHeaders = selectedHeaders
  },
  DELETE_SELECTED_HEADER (state, {tab, header}) {
    delete state.selectedHeaders[tab][header]
  }
}



// WEBPACK FOOTER //
// ./src/store/project/mutations.js